<template>
    <input class="rounded-md border border-solid border-black text-gray-700 py-2 px-3"
           v-mask="mask"
           :value="value" @input="$emit('input', $event.target.value)" ref="input">
</template>

<script>
    export default {
        props: ['value', 'mask'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>

